import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import './style.scoped.css';

const TabItem = (props) => {
  const {
    id,
    text,
    isActive,
    onClick,
    first,
    last
  } = props;

  const _handleClick = useCallback(() => {
    onClick(id);
  }, [id, onClick]);

  let classes = '';
  if(first || last) {
    if(first) {
      classes = 'left-tab';
    }else {
      classes = 'right-tab';
    }
  }

  if (isActive) {
    return (
      <div className={`tabItemActive ${classes}`} onClick={_handleClick}>
        <div className="flex-1 inputValueOnPrimary text-center">{text}</div>
      </div>
    );
  }
  return (
    <div className={`tabItemInactive ${classes}`} onClick={_handleClick}>
      <div className="flex-1 inputValue text-center">{text}</div>
    </div>
  );
};

interface Item {
  id: number,
  text: string,
}

interface TabSelectorProps {
  value: number;
  list: Item[];
  onChange: (id: number) => void;
}

const TabSelector = (props: TabSelectorProps) => {
  const {
    value,
    list,
    onChange,
  } = props;

  const { t } = useTranslation();

  const _handleClick = useCallback(
    (id) => {
      onChange(id);
    },
    [value, onChange]
  );

  return (
    <div>
      <div className="flex flex-row">
        {list.map((item, index) => {
          const isActive = item.id == value;
          return (
            <TabItem
              {...item}
              text={t(item.text)}
              isActive={isActive}
              onClick={_handleClick}
              key={item.id}
              first={index == 0}
              last={index == list.length - 1}
            />
          );
        })}
      </div>
    </div>
  );
};

export default TabSelector;
